<template>
    <div class="core">
        <div class="layui-fluid">
          <pub-search :search-type="'add'" :tableObj="tableObj" :searchConfig="searchConfig" exportTemplate="项目经理表.xlsx">
            <template>
              <button class="layui-btn" title="新增项目经理" @click="addService">
                <i class="layui-icon">&#xe624;</i>
                新增项目经理
              </button>
            </template>
           </pub-search>
            <layui-table
                ref="manager"
                table-name="YW_MANAGER"
                :beforeRender="handleBeforeRnder"
                :page-size="20"
                :page-range="6"
                :page-options="[10, 20, 50, 100]"
                :skin="'line'"
                :sort="['CREATE_TIME:DESC']"
                @table-event-edit="edit($event)"
                @table-event-check="check($event)"
                @table-event-del="$refs.manager.delRows($event.data)">
                <div>
                    <div checkbox="true" align="center" fixed="left" width="60"></div>
                    <!-- <div title="序号" width="60"  fixed="left" field="_NUMBER" align="center"></div> -->
                    <layui-tableconfig :config = "tableList"></layui-tableconfig>
                    <div rowspan="3" align="center" fixed="right" title="操作" width="130">
                        <script type="text/html" v-pre>
                            <a class=" layui-btn-xs" lay-event="check" style="cursor:pointer">查看</a>
                            <a class=" layui-btn-xs" lay-event="edit" style="cursor:pointer">编辑</a>
                            <a class="layui-btn-xs layui-btn-xs-danger" lay-event="del" style="cursor:pointer">删除</a>
                        </script>
                    </div>
                </div>
            </layui-table>
        </div>
        <manager-form v-if="managerForm" :visible.sync="managerForm" :formType="formType" :formData="formData"/>
    </div>
</template>
<script>
import "../../../utils/map/css/core.css"
import managerForm from './managerForm'

export default {
  name: 'manager',
  components: {
    managerForm
  },
  data () {
    return {
        tableList:[
          { field: 'MANAGER_BH', title: '项目经理编号', sort: true,  width: 150  },
          { field: 'MANAGER_NAME', title: '项目经理姓名', width: 200 },
          { field: 'MANAGER_PHONE', title: '联系电话',  width: 180 },
          { field: 'SSD_DESC', title: '所属地',  width: 300  },
          { field: 'ADDRESS', title: '地址',  width: 350 },
          { field: 'BZ', title: '备注'},
        ],
        searchConfig: {
          basic: [
            { TYPE:'input', WIDTH: 260,  FIELD: 'MANAGER_BH:2,MANAGER_NAME:2,MANAGER_PHONE:2,ADDRESS:2,SSX:2', PLACEHOLDER: '请输入搜索条件'},
          ],
          advanced: [
            { TYPE:'input', NAME: '项目经理编号 :', FIELD:'MANAGER_BH:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '项目经理姓名 :', FIELD:'MANAGER_NAME:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '联系电话 :', FIELD:'MANAGER_PHONE:2', PLACEHOLDER: '请输入查询条件'},
            // { TYPE:'input', NAME: '门店名称 :', FIELD:'SSX:2', PLACEHOLDER: '请输入查询条件'}
          ],
          showBatch: true
        },
        managerForm: false,
        formType: null,
        formData: null,
        tableObj: {
            checkedRows: 0,
            queryObject: {}
        },

    }
  },
  mounted(){
    this.tableObj = this.$refs.manager;
  },
  methods: {
    zqTreeSelect(treeRow){
      if(treeRow.jb == 1) {
        this.tableObj.queryObject.PROVINCE = treeRow.value;
      } else if(treeRow.jb == 2) {

      } else if(treeRow.jb == 3) {

      }
    },
    /**
     * 新增项目经理
     */
    addService () {
      this.managerForm = true;
      this.formType = 'add';
    },
    /**
     * 编辑表格
     */
    edit($event){
      this.formType = 'edit';
      this.formData = $event.data
      this.managerForm = true;
    },
    check($event){
      this.formType = 'check';
      this.formData = $event.data
      this.managerForm = true;
    },
    handleBeforeRnder(data){
      if(data && data.length > 0) {
        data.forEach((e) => {
          e.SSD = (e.PROVINCE ? e.PROVINCE : '') + "," + (e.CITY ? e.CITY : '') + "," + (e.DISTRICT ? e.DISTRICT : '')
          e.SSD_DESC = (e.PROVINCE ? e.PROVINCE_DESC : '') + "" + (e.CITY ? "-" + e.CITY_DESC: '') + "" + (e.DISTRICT ? "-" + e.DISTRICT_DESC : '')
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/person/projectManager/index.vue